import { useEffect, useRef, useState } from "react";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../assets/toastUtils";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "../../../Header/Header";
import NewSearchSateInput from "../../../NewSearchSateInput/NewSearchSateInput";
import Flatpickr from "react-flatpickr";
import styles from "./EditNewUiSearchFormActivity.module.scss";
import {
  calculateToDatePlus,
  currentDateSingle,
  getDateByMonth,
} from "../../../../utils/utils";
import PackagesStateInput from "../../../PackagesStateInput/PackagesStateInput";
import PackagesStateInputNewUi from "../../../PackagesStateInput/PackagesStateInputNewUi";
import {
  SvgCalender,
  SvgMan,
  SvgPlusCircle,
  SvgSearch,
} from "../../../../utils/svgIcons";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import NewMultiSelectSearchHolidays from "../../../NewSearchSateInput/NewMultiSelectSearchHolidays";

function EditNewUiSearchFormActivity({ searchType, setSelectedAddOns }) {
  const [modifyPkg, setModiyPkg] = useState(false);
  const [mobileHead, setMobileHead] = useState(false);

  const [destinationToggle, setdestinationToggle] = useState(false);
  const [selectedMultipleDestinations, setSelectedMultipleDestinations] =
    useState([]);
  const [width, setWidth] = useState(window.innerWidth);

  const { slug } = useParams();

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const toggleModify = () => {
    setModiyPkg(!modifyPkg);
  };
  const [dataFromChild, setDataFromChild] = useState("");

  const getDataFromChild = (data, resultArray) => {
    setDataFromChild(data);
    setSelectedMultipleDestinations([data])
    // setStateResultArray(resultArray)
    // console.log(resultArray);
  };
  //   console.log(dataFromChild, "getDataFromChild");

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [data, setData] = useState({ fromCity: "", toCity: "" });
  const [childAge, setChildAge] = useState([]);

  const [guest, setGuest] = useState(1);

  const [guestDetails, setIsguestDetails] = useState(false);
  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };

  const popupsRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popupsRef.current && !popupsRef.current.contains(event.target)) {
        setIsguestDetails(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const showErrorToast = (message) => {
    alert(message);
  };

  const [bookingData, setBookingData] = useState({});
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const data = {
      // hotelID: params.get("hotelID"),
      location: params.get("location"),
      adult: params.get("adult"),
      date: params.get("date"),
      month: params.get("month"),
      year: params.get("year"),
      multiple_destinations: params.get("selected_destinations"),
    };

    setData({
      fromCity: params.get("location"),
    });

    setSelectedMultipleDestinations(
      data.multiple_destinations
        ?.split(",")
        ?.map((item) => item.trim())
        ?.filter((item) => item !== "")
    );

    const date = `${data.year}-${String(data.month).padStart(2, "0")}-${String(
      data.date
    ).padStart(2, "0")}`;

    setGuest(params.get("adult") || 1);

    if (!data?.date) {
      // setBookingData({ ...data, date: currentDateSingle });
      const activityDate = new Date();
      activityDate.setDate(activityDate.getDate() + 7);
      setBookingData({ ...data, date: activityDate ? activityDate : currentDateSingle });
      return;
    }

    setBookingData({ ...data, date });
    // postBookingData(data);
  }, [location.search]);

  const handleMultiDestinationsChange = (selected) => {
    setSelectedMultipleDestinations(selected);
  };

  const navigate = useNavigate();

  // Date alterations
  const [loader, setLoader] = useState(false);

  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Click is outside the dropdown, so close it
      // setIsguestDetails(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
  };

  const handleSubmitButtonClickHandlerListingHotels = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=  ${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }
    setLoader(false);
    setModiyPkg(false);
    
    try {
      await navigate(
        `/listing-activities?location=${dataFromChild}&selected_destinations=${selectedMultipleDestinations}`,
        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };
  const handleSubmitButtonClickHandler = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    if (hasChildAgeError) {
      return;
    }
    setLoader(false);
    setModiyPkg(false);

    try {
      await navigate(
        `/listing-activities?location=${dataFromChild}&adult=${guest}&date=${new Date(
          bookingData?.date
        ).getDate()}&month=${
          new Date(bookingData?.date).getMonth() + 1
        }&year=${new Date(
          bookingData?.date
        ).getFullYear()}&selected_destinations=${selectedMultipleDestinations}`,
        undefined,
        {
          shallow: false,
        }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmitButtonSamePage = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    if (hasChildAgeError) {
      return;
    }
    setLoader(false);
    setModiyPkg(false);

    try {
      setSelectedAddOns([]);
      await navigate(
        `/single-activity/${slug}?location=${dataFromChild}&adult=${guest}&date=${new Date(
          bookingData?.date
        ).getDate()}&month=${
          new Date(bookingData?.date).getMonth() + 1
        }&year=${new Date(
          bookingData?.date
        ).getFullYear()}&selected_destinations=${selectedMultipleDestinations}`,
        undefined,
        {
          shallow: false,
        }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  useEffect(() => {
    if (window.innerWidth <= 640) {
      setMobileHead(true);
    } else {
      setMobileHead(false);
    }
  }, []);

  // listing_activities
  return (
    <section className={styles.EditSearchParentWrapper}>
      {searchType === "listing_activities" && (
        <div className={styles.singleSearch} id="singleSearch">
          <form
            action=""
            className={styles.EditSearchFormWrapper}
            id="main-form"
            onSubmit={handleSubmitButtonClickHandler}
          >
            {width <= 640 ? (
              <>
                {/* <div className={styles.EditSearchParentWrapperMobile}>
                  <div className="flex_align_center">
                    <span onClick={() => window.history.back()}>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
                          fill="#333333"
                        />
                      </svg>
                    </span>
                    <div className="SingleSearch-resp_content">
                      <h4 style={{ fontSize: "16px", lineHeight: "20px" }}>
                        {data?.fromCity ? (
                          capitalizeFirstLetter(data.fromCity)
                        ) : (
                          <p>Enter a destination</p>
                        )}
                      </h4>
                    </div>
                  </div>
                  <div onClick={toggleModify}>
                    {modifyPkg ? (
                      <span style={{ marginRight: "10px" }}>X</span>
                    ) : (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_2797_7470"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                        >
                          <rect width="20" height="20" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_2797_7470)">
                          <path
                            d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                    )}
                  </div>
                </div> */}
                <div className={styles.mobile_new_wrapper_container}>
                  <div
                    onClick={toggleModify}
                    className={styles.mobile_new_wrapper}
                  >
                    <div className={styles.mobile_new_left_div}>
                      <div>
                        {" "}
                        <SvgSearch />
                      </div>
                      <div className={styles.mobile_new_left_div_location}>
                        {data.fromCity &&
                          capitalizeFirstLetter(data.fromCity) + ", "}
                        <span>{getDateByMonth(bookingData?.date)}</span>
                      </div>
                    </div>

                    <div className={styles.mobile_new_right_div}>
                      <div className={styles.mobile_new_right_div_svg}>
                        <SvgMan />
                      </div>
                      <div className={styles.mobile_new_right_div_guest}>
                        {" "}
                        {guest}
                      </div>
                    </div>
                  </div>

                  {modifyPkg && (
                    <div className={styles.lower_form}>
                      <div style={{ marginBottom: "10px" }}>
                        <label htmlFor="">City/Destination</label>
                        {/* <PackagesStateInputNewUi
                          onDataChange={getDataFromChild}
                          width={width}
                        /> */}
                        <NewMultiSelectSearchHolidays
                          onClick={() => setdestinationToggle(true)}
                          onMultiSelectionChange={handleMultiDestinationsChange}
                          // selectedMultipleDestinations={selectedMultipleDestinations}
                          defaultSelected={selectedMultipleDestinations}
                          className={"search_form_input"}
                        />
                      </div>

                      <div
                        className={styles.mobile_travel_date_edit}
                        style={{ marginBottom: "10px" }}
                      >
                        <label htmlFor="">Travel Date</label>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "baseline",
                          }}
                        >
                          <div
                            className={`new_date_picker_react_js_custom_styling`}
                          >
                            <DatePicker
                              selected={bookingData?.date}
                              onChange={(date) =>
                                setBookingData((prev) => ({ ...prev, date }))
                              }
                              portalId="root-portal NewUIReactDatePicker"
                              popperPlacement="bottom-start"
                              minDate={new Date()}
                              dateFormat="dd MMM, yyyy"
                              placeholderText={
                                bookingData?.date
                                  ? format(bookingData?.date, "dd MMM, yyyy")
                                  : "Travel Date"
                              }
                            />
                          </div>
                          <div>
                            <SvgCalender />
                          </div>
                        </div>
                      </div>

                      <div className={styles.EditSearchFormChildThirdDiv}>
                        <label
                          onClick={dropdownGuestDetails}
                          className="search_label"
                        >
                          Guests{" "}
                          <svg
                            width="9"
                            height="5"
                            viewBox="0 0 9 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.25 0.75L4.75 4.25L1.25 0.75"
                              stroke="#BB735D"
                            />
                          </svg>
                        </label>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "baseline",
                          }}
                        >
                          <div
                            id="guest_input"
                            style={{ position: "relative" }}
                            className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                          >
                            <div
                              onClick={dropdownGuestDetails}
                              ref={dropdownRef}
                            >
                              <div className="optionCounter"></div>
                              <span id="adult_count">{guest}</span>
                              <span> Guests</span>
                            </div>
                            {guestDetails && (
                              <div
                                style={{ left: "0px" }}
                                className="guest_details_dropdown"
                                id="guestDetailsPopup"
                                ref={popupsRef}
                              >
                                    <div className="agent">
                                  <span>Guests</span>
                                  <div className="flex align_items_center">
                                    <button
                                      type="button"
                                      disabled={guest <= 1}
                                      className="optionCounterButton optionCounterButtonWithBorder"
                                      onClick={() => {
                                        if (guest <= 1) return;
                                        setGuest(Number(guest) - 1);
                                      }}
                                    >
                                      <span
                                        className="onclick_btn"
                                        id="adult_minus"
                                      >
                                        -
                                      </span>
                                    </button>

                                    <input
                                      className="optionCounterNumber"
                                      value={guest}
                                      min={1}
                                      type="number"
                                      onChange={(e) => setGuest(e.target.value)}
                                    />

                                    <button
                                      type="button"
                                      disabled={guest >= 11}
                                      className="optionCounterButton optionCounterButtonWithBorder"
                                      onClick={() => {
                                        if (guest >= 11) return;
                                        setGuest(Number(guest) + 1);
                                      }}
                                    >
                                      <span
                                        className="onclick_btn"
                                        id="adult_plus"
                                      >
                                        +
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div>
                            <SvgPlusCircle />
                          </div>
                        </div>
                      </div>

                      <button
                        // style={{ marginBottom: "10px" }}
                        type="submit"
                        className={styles.submitButton}
                      >
                        Modify
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                          >
                            <mask
                              id="mask0_6818_5962"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="15"
                              height="15"
                            >
                              <rect width="15" height="15" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_6818_5962)">
                              <path
                                d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className={styles.EditSearchFormParent}>
                <div className={styles.EditSearchFormChild}>
                  <div className={styles.EditSearchFormChildFirstDiv}>
                    {/* <PackagesStateInputNewUi onDataChange={getDataFromChild} width={width} /> */}
                    <NewMultiSelectSearchHolidays
                      onClick={() => setdestinationToggle(true)}
                      onMultiSelectionChange={handleMultiDestinationsChange}
                      // selectedMultipleDestinations={selectedMultipleDestinations}
                      defaultSelected={selectedMultipleDestinations}
                      className={"search_form_input"}
                    />
                  </div>
                  <div
                    className={`${styles.EditSearchFormChildSecondDiv} new_date_picker_react_js_custom_styling`}
                  >
                    {/* <Flatpickr
                      i
                      className="m_0 testform_input pac-target-input"
                      color="#ffffff"
                      value={bookingData?.date}
                      onChange={([date]) =>
                        setBookingData((prev) => ({ ...prev, date }))
                      }
                      min={new Date()}
                    /> */}

                    <DatePicker
                      showIcon
                      selected={bookingData?.date}
                      onChange={(date) =>
                        setBookingData((prev) => ({ ...prev, date }))
                      }
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()}
                      dateFormat="dd MMM, yyyy"
                      placeholderText={
                        bookingData?.date
                          ? format(bookingData?.date, "dd MMM, yyyy")
                          : "Travel Date"
                      }
                    />
                  </div>
                  <div className={styles.EditSearchFormChildThirdDiv}>
                    <div
                      id="guest_input"
                      style={{ position: "relative" }}
                      className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                    >
                      <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                        <div className="optionCounter"></div>
                        <span id="adult_count">{guest}</span>
                        <span> Guests</span>
                      </div>
                      {guestDetails && (
                        <div
                          style={{ left: "0px" }}
                          className="guest_details_dropdown"
                          id="guestDetailsPopup"
                          ref={popupsRef}
                        >
                              <div className="agent">
                            <span>Guests</span>
                            <div className="flex align_items_center">
                              <button
                                type="button"
                                disabled={guest <= 1}
                                className="optionCounterButton optionCounterButtonWithBorder"
                                onClick={() => {
                                  if (guest <= 1) return;
                                  setGuest(Number(guest) - 1);
                                }}
                              >
                                <span className="onclick_btn" id="adult_minus">
                                  -
                                </span>
                              </button>

                              <input
                                className="optionCounterNumber"
                                value={guest}
                                min={1}
                                type="number"
                                onChange={(e) => setGuest(e.target.value)}
                              />

                              <button
                                type="button"
                                disabled={guest >= 11}
                                className="optionCounterButton optionCounterButtonWithBorder"
                                onClick={() => {
                                  if (guest >= 11) return;
                                  setGuest(Number(guest) + 1);
                                }}
                              >
                                <span className="onclick_btn" id="adult_plus">
                                  +
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <button type="submit" className={styles.submitButton}>
                  Modify
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <mask
                        id="mask0_6818_5962"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="15"
                        height="15"
                      >
                        <rect width="15" height="15" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6818_5962)">
                        <path
                          d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                </button>
              </div>
            )}
          </form>
        </div>
      )}

      {searchType === "all_activities" && (
        <div className={styles.singleSearch} id="singleSearch">
          <form
            action=""
            className={styles.EditSearchFormWrapper}
            id="main-form"
            onSubmit={handleSubmitButtonClickHandler}
          >
            {width <= 640 ? (
              <>
                {/* <div className={styles.EditSearchParentWrapperMobile}>
                  <div className="flex_align_center">
                    <span onClick={() => window.history.back()}>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
                          fill="#333333"
                        />
                      </svg>
                    </span>
                    <div className="SingleSearch-resp_content">
                      <h4 style={{ fontSize: "16px", lineHeight: "20px" }}>
                        {data?.fromCity ? (
                          capitalizeFirstLetter(data.fromCity)
                        ) : (
                          <p>Enter a destination</p>
                        )}
                      </h4>
                    </div>
                  </div>
                  <div onClick={toggleModify}>
                    {modifyPkg ? (
                      <span style={{ marginRight: "10px" }}>X</span>
                    ) : (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_2797_7470"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                        >
                          <rect width="20" height="20" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_2797_7470)">
                          <path
                            d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                    )}
                  </div>
                </div> */}
                <div className={styles.mobile_new_wrapper_container}>
                  <div
                    onClick={toggleModify}
                    className={styles.mobile_new_wrapper}
                  >
                    <div className={styles.mobile_new_left_div}>
                      <div>
                        {" "}
                        <SvgSearch />
                      </div>
                      <div className={styles.mobile_new_left_div_location}>
                        {data.fromCity &&
                          capitalizeFirstLetter(data.fromCity) + ", "}
                        <span>{getDateByMonth(bookingData?.date)}</span>
                      </div>
                    </div>

                    <div className={styles.mobile_new_right_div}>
                      <div className={styles.mobile_new_right_div_svg}>
                        <SvgMan />
                      </div>
                      <div className={styles.mobile_new_right_div_guest}>
                        {" "}
                        {guest}
                      </div>
                    </div>
                  </div>

                  {modifyPkg && (
                    <>
                      <div className={styles.lower_form}>
                        <div style={{ marginBottom: "10px" }}>
                          <label htmlFor="">City/Destination</label>
                          {/* <GooglePlaceApi
                        setSelectedLocation={setSelectedLocation}
                        data={data}
                        defaultValue={data?.fromCity && data.fromCity}
                        setData={setData}
                        showErrorToast={showErrorToast}
                        position={"SingleSearchForm"}
                      /> */}
                          <PackagesStateInputNewUi
                            onDataChange={getDataFromChild}
                            width={width}
                          />
                        </div>
                        <div
                          className={styles.mobile_travel_date_edit}
                          style={{ marginBottom: "10px" }}
                        >
                          <label htmlFor="">Travel Date</label>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "baseline",
                            }}
                          >
                            <div
                              className={`new_date_picker_react_js_custom_styling`}
                            >
                              <DatePicker
                                selected={bookingData?.date}
                                onChange={(date) =>
                                  setBookingData((prev) => ({ ...prev, date }))
                                }
                                portalId="root-portal NewUIReactDatePicker"
                                popperPlacement="bottom-start"
                                minDate={new Date()}
                                dateFormat="dd MMM, yyyy"
                                placeholderText={
                                  bookingData?.date
                                    ? format(bookingData?.date, "dd MMM, yyyy")
                                    : "Travel Date"
                                }
                              />
                            </div>
                            <div>
                              <SvgCalender />
                            </div>
                          </div>
                        </div>

                        <div className={styles.EditSearchFormChildThirdDiv}>
                          <label
                            onClick={dropdownGuestDetails}
                            className="search_label"
                          >
                            Guests{" "}
                            <svg
                              width="9"
                              height="5"
                              viewBox="0 0 9 5"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.25 0.75L4.75 4.25L1.25 0.75"
                                stroke="#BB735D"
                              />
                            </svg>
                          </label>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "baseline",
                            }}
                          >
                            <div
                              id="guest_input"
                              style={{ position: "relative" }}
                              className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                            >
                              <div
                                onClick={dropdownGuestDetails}
                                ref={dropdownRef}
                              >
                                <div className="optionCounter"></div>
                                <span id="adult_count">{guest}</span>
                                <span> Guests</span>
                              </div>
                              {guestDetails && (
                                <div
                                  style={{ left: "0px" }}
                                  className="guest_details_dropdown"
                                  id="guestDetailsPopup"
                                  ref={popupsRef}
                                >
                                      <div className="agent">
                                    <span>Guests</span>
                                    <div className="flex align_items_center">
                                      <button
                                        type="button"
                                        disabled={guest <= 1}
                                        className="optionCounterButton optionCounterButtonWithBorder"
                                        onClick={() => {
                                          if (guest <= 1) return;
                                          setGuest(Number(guest) - 1);
                                        }}
                                      >
                                        <span
                                          className="onclick_btn"
                                          id="adult_minus"
                                        >
                                          -
                                        </span>
                                      </button>

                                      <input
                                        className="optionCounterNumber"
                                        value={guest}
                                        min={1}
                                        type="number"
                                        onChange={(e) =>
                                          setGuest(e.target.value)
                                        }
                                      />

                                      <button
                                        type="button"
                                        disabled={guest >= 11}
                                        className="optionCounterButton optionCounterButtonWithBorder"
                                        onClick={() => {
                                          if (guest >= 11) return;
                                          setGuest(Number(guest) + 1);
                                        }}
                                      >
                                        <span
                                          className="onclick_btn"
                                          id="adult_plus"
                                        >
                                          +
                                        </span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div>
                              <SvgPlusCircle />
                            </div>
                          </div>
                        </div>

                        <button
                          style={{ marginBottom: "10px" }}
                          type="submit"
                          className={styles.submitButton}
                        >
                          Modify
                          <span> 
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15"
                              height="15"
                              viewBox="0 0 15 15"
                              fill="none"
                            >
                              <mask
                                id="mask0_6818_5962"
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="15"
                                height="15"
                              >
                                <rect width="15" height="15" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_6818_5962)">
                                <path
                                  d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                                  fill="white"
                                />
                              </g>
                            </svg>
                          </span>
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </>
            ) : (
              <div className={styles.EditSearchFormParent}>
                <div className={styles.EditSearchFormChild}>
                  <div className={styles.EditSearchFormChildFirstDiv}>
                    <PackagesStateInputNewUi
                      onDataChange={getDataFromChild}
                      width={width}
                    />
                  </div>
                  <div
                    className={`${styles.EditSearchFormChildSecondDiv} new_date_picker_react_js_custom_styling`}
                  >
                    {/* <Flatpickr
                      i
                      className="m_0 testform_input pac-target-input"
                      color="#ffffff"
                      value={bookingData?.date}
                      onChange={([date]) =>
                        setBookingData((prev) => ({ ...prev, date }))
                      }
                      min={new Date()}
                    /> */}

                    <DatePicker
                      showIcon
                      selected={bookingData?.date}
                      onChange={(date) =>
                        setBookingData((prev) => ({ ...prev, date }))
                      }
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()}
                      dateFormat="dd MMM, yyyy"
                      placeholderText={
                        bookingData?.date
                          ? format(bookingData?.date, "dd MMM, yyyy")
                          : "Travel Date"
                      }
                    />
                  </div>
                  <div className={styles.EditSearchFormChildThirdDiv}>
                    <p
                      id="guest_input"
                      style={{ position: "relative" }}
                      className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                    >
                      <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                        <div className="optionCounter"></div>
                        <span id="adult_count">{guest}</span>
                        <span> Guests</span>
                      </div>
                      {guestDetails && (
                        <div
                          style={{ left: "0px" }}
                          className="guest_details_dropdown"
                          id="guestDetailsPopup"
                          ref={popupsRef}
                        >
                             <div className="agent">
                            <span>Guests</span>
                            <div className="flex align_items_center">
                              <button
                                type="button"
                                disabled={guest <= 1}
                                className="optionCounterButton optionCounterButtonWithBorder"
                                onClick={() => {
                                  if (guest <= 1) return;
                                  setGuest(Number(guest) - 1);
                                }}
                              >
                                <span className="onclick_btn" id="adult_minus">
                                  -
                                </span>
                              </button>

                              <input
                                className="optionCounterNumber"
                                value={guest}
                                min={1}
                                type="number"
                                onChange={(e) => setGuest(e.target.value)}
                              />

                              <button
                                type="button"
                                disabled={guest >= 11}
                                className="optionCounterButton optionCounterButtonWithBorder"
                                onClick={() => {
                                  if (guest >= 11) return;
                                  setGuest(Number(guest) + 1);
                                }}
                              >
                                <span className="onclick_btn" id="adult_plus">
                                  +
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </p>
                  </div>
                </div>
                <button type="submit" className={styles.submitButton}>
                  Modify
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <mask
                        id="mask0_6818_5962"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="15"
                        height="15"
                      >
                        <rect width="15" height="15" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6818_5962)">
                        <path
                          d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                </button>
              </div>
            )}
          </form>
        </div>
      )}

      {searchType === "single_activity" && (
        <div className={styles.singleSearch} id="singleSearch">
          <form
            action=""
            className={styles.EditSearchFormWrapper}
            id="main-form"
            onSubmit={handleSubmitButtonSamePage}
          >
            {width <= 640 ? (
              <>
                {/* <div className={styles.EditSearchParentWrapperMobile}>
                  <div className="flex_align_center">
                    <span onClick={() => window.history.back()}>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
                          fill="#333333"
                        />
                      </svg>
                    </span>
                    <div className="SingleSearch-resp_content">
                      <h4 style={{ fontSize: "16px", lineHeight: "20px" }}>
                        {data?.fromCity ? (
                          capitalizeFirstLetter(data.fromCity)
                        ) : (
                          <p>Enter a destination</p>
                        )}
                      </h4>
                    </div>
                  </div>
                  <div onClick={toggleModify}>
                    {modifyPkg ? (
                      <span style={{ marginRight: "10px" }}>X</span>
                    ) : (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_2797_7470"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                        >
                          <rect width="20" height="20" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_2797_7470)">
                          <path
                            d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                    )}
                  </div>
                </div> */}
                <div className={styles.mobile_new_wrapper_container}>
                  <div
                    onClick={toggleModify}
                    className={styles.mobile_new_wrapper}
                  >
                    <div className={styles.mobile_new_left_div}>
                      <div>
                        {" "}
                        <SvgSearch />
                      </div>
                      <div className={styles.mobile_new_left_div_location}>
                        {data.fromCity &&
                          capitalizeFirstLetter(data.fromCity) + ", "}
                        <span>{getDateByMonth(bookingData?.date)}</span>
                      </div>
                    </div>

                    <div className={styles.mobile_new_right_div}>
                      <div className={styles.mobile_new_right_div_svg}>
                        <SvgMan />
                      </div>
                      <div className={styles.mobile_new_right_div_guest}>
                        {" "}
                        {guest}
                      </div>
                    </div>
                  </div>

                  {modifyPkg && (
                    <>
                      <div className={styles.lower_form}>
                        {/* <div style={{ marginBottom: "10px" }}>
                          <label htmlFor="">City/Destination</label>
                          <PackagesStateInputNewUi
                            onDataChange={getDataFromChild}
                            width={width}
                          />
                        </div> */}
                        <div
                          className={styles.mobile_travel_date_edit}
                          style={{ marginBottom: "10px" }}
                        >
                          <label htmlFor="">Travel Date</label>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "baseline",
                            }}
                          >
                            <div
                              className={`new_date_picker_react_js_custom_styling`}
                            >
                              <DatePicker
                                selected={bookingData?.date}
                                onChange={(date) =>
                                  setBookingData((prev) => ({ ...prev, date }))
                                }
                                portalId="root-portal NewUIReactDatePicker"
                                popperPlacement="bottom-start"
                                minDate={new Date()}
                                dateFormat="dd MMM, yyyy"
                                placeholderText={
                                  bookingData?.date
                                    ? format(bookingData?.date, "dd MMM, yyyy")
                                    : "Travel Date"
                                }
                              />
                            </div>
                            <div>
                              <SvgCalender />
                            </div>
                          </div>
                        </div>

                        <div className={styles.EditSearchFormChildThirdDiv}>
                          <label
                            onClick={dropdownGuestDetails}
                            className="search_label"
                          >
                            Guests{" "}
                            <svg
                              width="9"
                              height="5"
                              viewBox="0 0 9 5"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.25 0.75L4.75 4.25L1.25 0.75"
                                stroke="#BB735D"
                              />
                            </svg>
                          </label>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "baseline",
                            }}
                          >
                            <div
                              id="guest_input"
                              style={{ position: "relative" }}
                              className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                            >
                              <div
                                onClick={dropdownGuestDetails}
                                ref={dropdownRef}
                              >
                                <div className="optionCounter"></div>
                                <span id="adult_count">{guest}</span>
                                <span> Guests</span>
                              </div>
                              {guestDetails && (
                                <div
                                  style={{ left: "0px" }}
                                  className="guest_details_dropdown"
                                  id="guestDetailsPopup"
                                  ref={popupsRef}
                                >
                                      <div className="agent">
                                    <span>Guests</span>
                                    <div className="flex align_items_center">
                                      <button
                                        type="button"
                                        disabled={guest <= 1}
                                        className="optionCounterButton optionCounterButtonWithBorder"
                                        onClick={() => {
                                          if (guest <= 1) return;
                                          setGuest(Number(guest) - 1);
                                        }}
                                      >
                                        <span
                                          className="onclick_btn"
                                          id="adult_minus"
                                        >
                                          -
                                        </span>
                                      </button>

                                      <input
                                        className="optionCounterNumber"
                                        value={guest}
                                        min={1}
                                        type="number"
                                        onChange={(e) =>
                                          setGuest(e.target.value)
                                        }
                                      />

                                      <button
                                        type="button"
                                        disabled={guest >= 11}
                                        className="optionCounterButton optionCounterButtonWithBorder"
                                        onClick={() => {
                                          if (guest >= 11) return;
                                          setGuest(Number(guest) + 1);
                                        }}
                                      >
                                        <span
                                          className="onclick_btn"
                                          id="adult_plus"
                                        >
                                          +
                                        </span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div>
                              <SvgPlusCircle />
                            </div>
                          </div>
                        </div>

                        <button
                          style={{ marginBottom: "10px" }}
                          type="submit"
                          className={styles.submitButton}
                        >
                          Modify
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15"
                              height="15"
                              viewBox="0 0 15 15"
                              fill="none"
                            >
                              <mask
                                id="mask0_6818_5962"
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="15"
                                height="15"
                              >
                                <rect width="15" height="15" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_6818_5962)">
                                <path
                                  d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                                  fill="white"
                                />
                              </g>
                            </svg>
                          </span>
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </>
            ) : (
              <div className={styles.EditSearchFormParent}>
                <div className={styles.EditSearchFormChild}>
                  {/* <div className={styles.EditSearchFormChildFirstDiv}>
                    <PackagesStateInputNewUi
                      onDataChange={getDataFromChild}
                      width={width}
                    />
                  </div> */}
                  <div
                    className={`${styles.EditSearchFormChildSecondDiv} new_date_picker_react_js_custom_styling`}
                  >
                    {/* <Flatpickr
                      i
                      className="m_0 testform_input pac-target-input"
                      color="#ffffff"
                      value={bookingData?.date}
                      onChange={([date]) =>
                        setBookingData((prev) => ({ ...prev, date }))
                      }
                      min={new Date()}
                    /> */}

                    <DatePicker
                      showIcon
                      selected={bookingData?.date}
                      onChange={(date) =>
                        setBookingData((prev) => ({ ...prev, date }))
                      }
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()}
                      dateFormat="dd MMM, yyyy"
                      placeholderText={
                        bookingData?.date
                          ? format(bookingData?.date, "dd MMM, yyyy")
                          : "Travel Date"
                      }
                    />
                  </div>
                  <div className={styles.EditSearchFormChildThirdDiv}>
                    <div
                      id="guest_input"
                      style={{ position: "relative" }}
                      className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                    >
                      <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                        <div className="optionCounter"></div>
                        <span id="adult_count">{guest}</span>
                        <span> Guests</span>
                      </div>
                      {guestDetails && (
                        <div
                          style={{ left: "0px" }}
                          className="guest_details_dropdown"
                          id="guestDetailsPopup"
                          ref={popupsRef}
                        >
                              <div className="agent">
                            <span>Guests</span>
                            <div className="flex align_items_center">
                              <button
                                type="button"
                                disabled={guest <= 1}
                                className="optionCounterButton optionCounterButtonWithBorder"
                                onClick={() => {
                                  if (guest <= 1) return;
                                  setGuest(Number(guest) - 1);
                                }}
                              >
                                <span className="onclick_btn" id="adult_minus">
                                  -
                                </span>
                              </button>

                              <input
                                className="optionCounterNumber"
                                value={guest}
                                min={1}
                                type="number"
                                onChange={(e) => setGuest(e.target.value)}
                              />

                              <button
                                type="button"
                                disabled={guest >= 11}
                                className="optionCounterButton optionCounterButtonWithBorder"
                                onClick={() => {
                                  if (guest >= 11) return;
                                  setGuest(Number(guest) + 1);
                                }}
                              >
                                <span className="onclick_btn" id="adult_plus">
                                  +
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <button type="submit" className={styles.submitButton}>
                  Modify
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <mask
                        id="mask0_6818_5962"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="15"
                        height="15"
                      >
                        <rect width="15" height="15" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6818_5962)">
                        <path
                          d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                </button>
              </div>
            )}
          </form>
        </div>
      )}

      {/* {searchType === "all_activities" && (
        <div className={styles.singleSearch} id="singleSearch">
          <form
            action=""
            className={styles.EditSearchFormWrapper}
            id="main-form"
            onSubmit={handleSubmitButtonClickHandler}
          >
            {width <= 640 ? (
              <>
                <div className={styles.EditSearchParentWrapperMobile}>
                  <div className="flex_align_center">
                    <span onClick={() => window.history.back()}>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
                          fill="#333333"
                        />
                      </svg>
                    </span>
                    <div className="SingleSearch-resp_content">
                      <h4 style={{ fontSize: "16px", lineHeight: "20px" }}>
                        {data?.fromCity ? (
                          capitalizeFirstLetter(data.fromCity)
                        ) : (
                          <p>Enter a destination</p>
                        )}
                      </h4>
                    </div>
                  </div>
                  <div onClick={toggleModify}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_2797_7470"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_2797_7470)">
                        <path
                          d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
                {modifyPkg && (
                  <>
                    <div>
                      <label htmlFor="">City/Destination</label>
                      <PackagesStateInputNewUi
                        onDataChange={getDataFromChild}
                      />
                    </div>
                    <button
                      style={{ marginBottom: "10px" }}
                      type="submit"
                      className={styles.submitButton}
                    >
                      Modify
                      <span>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="12"
                          viewBox="0 0 17 12"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_6093_5578)">
                            <path
                              d="M16.5488 5.27416C12.5086 4.76301 11.0605 0.540892 11.0395 0.5L10.0426 0.816914C10.0951 0.980483 11.1235 3.97584 13.9253 5.48885H0V6.51115H13.9253C11.134 8.02416 10.0951 11.0297 10.0426 11.1831L11.0395 11.5C11.0395 11.5 12.5086 7.23699 16.5488 6.72584L17.0105 6.6645V5.32528L16.5488 5.26394V5.27416Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_6093_5578">
                              <rect
                                width="17"
                                height="11"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </button>
                  </>
                )}
              </>
            ) : (
              <div className={styles.EditSearchFormParent}>
                <div className={styles.EditSearchFormChild}>
                  <div className={styles.EditSearchFormChildFirstDiv}>
                    <PackagesStateInputNewUi onDataChange={getDataFromChild} />
                  </div>
                  <div className={styles.EditSearchFormChildSecondDiv}>
                    <p
                      id="guest_input"
                      style={{ position: "relative" }}
                      className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                    >
                      <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                        <div className="optionCounter"></div>
                        <span id="adult_count">{guest}</span>
                        <span> Guests</span>
                      </div>
                      {guestDetails && (
                        <div
                          style={{ left: "0px" }}
                          className="guest_details_dropdown"
                          id="guestDetailsPopup"
                          ref={popupsRef}
                        >
                          <div className="agent">
                            <span>Guests</span>
                            <div>
                              <button
                                type="button"
                                disabled={guest <= 1}
                                className="optionCounterButton optionCounterButtonWithBorder"
                                onClick={() => {
                                  if (guest <= 1) return;
                                  setGuest(Number(guest) - 1);
                                }}
                              >
                                <span className="onclick_btn" id="adult_minus">
                                  -
                                </span>
                              </button>

                              <input
                                className="optionCounterNumber"
                                value={guest}
                                min={1}
                                type="number"
                                onChange={(e) => setGuest(e.target.value)}
                              />

                              <button
                                type="button"
                                disabled={guest >= 11}
                                className="optionCounterButton optionCounterButtonWithBorder"
                                onClick={() => {
                                  if (guest >= 11) return;
                                  setGuest(Number(guest) + 1);
                                }}
                              >
                                <span className="onclick_btn" id="adult_plus">
                                  +
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </p>
                  </div>
                </div>
                <button type="submit" className={styles.submitButton}>
                  Modify
                  <span>
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="12"
                      viewBox="0 0 17 12"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_6093_5578)">
                        <path
                          d="M16.5488 5.27416C12.5086 4.76301 11.0605 0.540892 11.0395 0.5L10.0426 0.816914C10.0951 0.980483 11.1235 3.97584 13.9253 5.48885H0V6.51115H13.9253C11.134 8.02416 10.0951 11.0297 10.0426 11.1831L11.0395 11.5C11.0395 11.5 12.5086 7.23699 16.5488 6.72584L17.0105 6.6645V5.32528L16.5488 5.26394V5.27416Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6093_5578">
                          <rect
                            width="17"
                            height="11"
                            fill="white"
                            transform="translate(0 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </button>
              </div>
            )}
          </form>
        </div>
      )} */}
      {/* <input type="hidden" name="hotelId" value="{{ $hotelId }}" /> */}
    </section>
  );
}

export default EditNewUiSearchFormActivity;
